import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { Layout, Menu, MenuProps } from 'antd';
import { CognitoUser } from '../../lib/cognito/CognitoUser';
import {
  HomeOutlined,
  BankOutlined,
  PictureOutlined,
  SmileOutlined,
  IdcardOutlined,
  SettingOutlined,
  UserOutlined,
  BarsOutlined,
  LogoutOutlined,
  PicRightOutlined,
} from '@ant-design/icons';

const { Sider } = Layout;

type Props = {
  collapsed: boolean;
};

const Header = styled.div`
  height: 7rem;
`;

const Label = styled.span`
  font-family: 'Sarabun', sans-serif;
  color: #b4c9de;
  font-size: 1.6rem;
  text-decoration: none;
  user-select: none;
  font-weight: 400;
`;

//['items'][number] access any element of the items prop of MenuProps. 
// Required utility => all properties are required.
type MenuItem = Required<MenuProps>['items'][number]; 

function getItem(
  key: React.Key,
  label: React.ReactNode,
  icon?: React.ReactNode,
  onClick?: () => void,
  children?: MenuItem[],
  type?: 'group',
): MenuItem {
  return {
    key,
    icon,
    onClick,
    children,
    label,
    type,
  } as MenuItem;
}


export const Drawer: React.FunctionComponent<Props> = ({ collapsed }) => {
  const navigate = useNavigate();

  const items: MenuItem[] = [
    getItem("1", <Label>Dashboard</Label>,  <BankOutlined />, () => navigate('/')),
    getItem("2", <Label>Landing</Label>, <HomeOutlined />, () => navigate('/landings')),
    getItem("3", <Label>Sales</Label>, <UserOutlined /> , undefined, [
      getItem("3.1", <Label>Inventory</Label>, undefined, () => navigate('/inventory')),
      getItem("3.2", <Label>Orders</Label>, undefined, () => navigate('/orders')),
      getItem("3.3", <Label>Carts</Label>, undefined, () => navigate('/carts')),
    ]),
    getItem("4", <Label>Artworks</Label>, <PictureOutlined />, () => navigate('/artworks')),
    getItem("5", <Label>Artists</Label>, <SmileOutlined />, () => navigate('/artists')),
    getItem("6", <Label>Magazine</Label>, <PicRightOutlined />, undefined, [
      getItem("6.1", <Label>Articles</Label>, undefined, () => navigate('/magazine/articles')),
      getItem("6.2", <Label>Authors</Label>, undefined, () => navigate('/authors')),
      getItem("6.3", <Label>Tags</Label>, undefined, () => navigate('/tags')),
    ]),
    getItem("7", <Label>Collections</Label>, <BarsOutlined />, () => navigate('/collections')),
    getItem("8", <Label>Galleries</Label>, <BankOutlined />, () => navigate('/galleries')),
    getItem("9", <Label>Customers</Label>, <IdcardOutlined />, () => navigate('/customers')),
    getItem("10", <Label>Settings</Label>, <SettingOutlined />, () => navigate('/settings')),
    {
      key: "11",
      type: 'divider',
    },
    getItem("12", <Label>Logout</Label>, <LogoutOutlined />, () => {
      const cognitoUser = new CognitoUser();
      cognitoUser.signOut();
      navigate('/login');
    })
  ];

  return (
    <Sider collapsible collapsed={collapsed} breakpoint="lg" collapsedWidth="0" trigger={null}>
      <Header />

      <Menu theme="dark" mode="inline" defaultSelectedKeys={['1']} items={items} />

    </Sider>
  );
};


